import { render } from "./contact_page.vue?vue&type=template&id=3015f5c5"
import script from "./contact_page.vue?vue&type=script&lang=js"
export * from "./contact_page.vue?vue&type=script&lang=js"

import "./contact_page.vue?vue&type=style&index=0&id=3015f5c5&lang=css"
script.render = render

export default script